import { CustomRuleData, useGetAllRulesQuery } from 'store/api/rules'
import { useLocation } from '@reach/router'
import { AnalyticsNavRelativePath } from 'components/Dashboard/NavBar/AnalyticsNavMenu'
import { useAppSelector } from 'store/hooks'
import { useGetProfilesQuery } from 'store/api/profiles'

export function useGetExistingDraftRule(): {
  existingDraftRule: CustomRuleData | undefined
  areRulesLoading: boolean
  isUninitialized: boolean
  isAnalytics: boolean
  isStatistics: boolean
} {
  const location = useLocation()
  const isAnalytics = [
    AnalyticsNavRelativePath.STATISTICS,
    AnalyticsNavRelativePath.ACTIVITY_LOG,
    AnalyticsNavRelativePath.DOMAIN_TEST,
  ].some(path => location.pathname.includes(path))
  const isStatistics = location.pathname.endsWith(AnalyticsNavRelativePath.STATISTICS)
  const draftCustomRuleProfileId = useAppSelector(s => s.ruleTray.draftCustomRule.profileId)
  const draftCustomRulePk = useAppSelector(s => s.ruleTray.draftCustomRule.PK)
  const sessionToken = useAppSelector(s => s.session.sessionToken)
  const { data: profilesData } = useGetProfilesQuery('', { skip: !sessionToken })

  const isSharedProfile = !!profilesData?.shared_profiles?.find(
    profile => profile.PK === draftCustomRuleProfileId,
  )

  const {
    data: allRulesData,
    isLoading,
    isUninitialized,
  } = useGetAllRulesQuery(
    {
      profileId: draftCustomRuleProfileId?.toString() ?? '',
      ignoreImpersonation: isSharedProfile,
    },
    {
      skip: !draftCustomRuleProfileId?.toString() || !isAnalytics,
      refetchOnMountOrArgChange: true,
    },
  )

  return {
    existingDraftRule: allRulesData?.rules?.find(rule => rule.PK === draftCustomRulePk),
    areRulesLoading: isLoading,
    isAnalytics,
    isUninitialized,
    isStatistics,
  }
}
